import { Case } from 'services';
export const CaseIdentityMock: Case[] = [
  {
    id: 'CI-001',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Real Name","value":"Bad Realname"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CI-002',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Real Name","value":"Bad Realname"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CI-003',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Real Name","value":"Bad Realname"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CI-004',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Real Name","value":"Bad Realname"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CI-005',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Real Name","value":"Bad Realname"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CI-006',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Real Name","value":"Bad Realname"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CI-007',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Real Name","value":"Bad Realname"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CI-008',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Gamertag","value":"BadTag0248768795"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CI-009',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Real Name","value":"Bad Realname"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CI-010',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Gamertag","value":"BadGamertag"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CI-011',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Real Name","value":"Bad Realname"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CI-012',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '59705781',
      subjectType: 'Identity',
      subjectValue: '{"output":[{"type":"headerValue","value":{"header":"Real Name","value":"Bad Realname"}}]}',
      subjectLabels: ['Gamertag'],
      subjectOwners: [
        {
          userId: '59705781',
          username: 'BlestShark',
          userType: 'Xuid'
        }
      ],
      subjectHashes: {
        text: 'Bad'
      },
      subjectMetadata: undefined
    },
    caseEvidence: {},
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  }
];
